import React from "react";
import { Loader } from "semantic-ui-react";
import { gql, useQuery, TypedDocumentNode } from "@apollo/client";
import useRoute from "../../router/useRoute";
import UnreadCommentsTag from "./UnreadCommentsTag";

interface IUnreadCommentsForDocProps {
  documentId: string;
  documentType: "shipment";
}

const GET_COUNT_FOR_DOCUMENT: TypedDocumentNode<
  { unread: { documentId: string, documentType: string, count: number } },
  { input: { documentId: string; documentType: string } }
> = gql`
  query getUnreadCommentsForDocumentTag($input: GetConversationForDocumentInput!) {
    unread: getUnreadCommentsForDocument(input: $input) {
      documentId
      documentType
      count
    }
  }
`
export default function UnreadCommentsForDoc({ documentId, documentType }: IUnreadCommentsForDocProps) {
  const { goRoute } = useRoute();
  const { data, loading } = useQuery(GET_COUNT_FOR_DOCUMENT, { variables: { input: { documentId, documentType } }, skip: !(documentId && documentType) })
  if (loading) return <Loader inline active />
  const count = data?.unread?.count || 0;
  const onClick = () => {
    switch (documentType) {
      case "shipment": goRoute("shipment", { _id: documentId, section: "discussions" });
      default:
    }
  }
  return <UnreadCommentsTag
    count={count}
    onClick={onClick}
  />
}
